import _ from 'lodash';
import locationData from './locations';
import {MiscEndpoints} from "../../common/ProxyEndpoints";

//  backing store
let locations = locationData;

//  cache for province
let provinceCache;

export const initLocationsData = async (proxy) => {

    try{

        const res = await proxy.processRequest(MiscEndpoints.listAllLocations());
        if(res.ok){
            locations = res.getPayload();
        }

    }
    catch (e) {

        //  failed capturing location info

    }


};

export const listProvinces = (order = true) => {

    return provinceCache || (provinceCache = _.sortBy(_.uniqBy(locations, 'province'),'province').map((x,index) => ({
        value: x.province,
        text: x.province,
    })));

};

export const getLocationRecord = (payload) => {
    return locations.find(x => x.district === payload['district'] && x.ward_number === payload['ward'] && x.province === payload['province']);
};

export const getDistricts = (province,order = true) => {

    return _.sortBy(_.uniqBy(locations.filter(x => x.province === province),'district'),'district').map((x,index) => ({
        value: x.district,
        text: x.district,
    }));

};

export const getWards = (province,district, order = true) => {

    return _.sortBy(locations.filter(x => x.province === province && x.district === district),x => Number(x.ward_number.replace("Ward",'').trim()) ).map((x,index) => ({
        value:  x.ward_number,
        text: x.ward_number,
    }));

};



// WEBPACK FOOTER //
// ./src/data/locations/index.js